import {
	apiClient,
	getAuthHeaders,
	handleServiceError,
} from 'api/config/config';

// User Services
export const userService = {
	// --- PROFILE UPDATES --- //
	updateMetadata: async (token, meta) => {
		try {
			return await apiClient.put(
				'client/user/partial-update',
				{
					metadata: JSON.stringify(meta),
				},
				getAuthHeaders(token)
			);
		} catch (error) {
			handleServiceError(error);
		}
	},
	updateProfile: async (token, user) => {
		try {
			return await apiClient.put(
				'client/user/partial-update',
				{
					username: user.username,
					firstName: user.firstName,
					lastName: user.lastName,
					email: user.email,
					lightningAddress: user.lightningAddress,
				},
				getAuthHeaders(token)
			);
		} catch (error) {
			handleServiceError(error);
		}
	},
	updatePushNotificationToken: async (token, pushToken) => {
		try {
			return await apiClient.put(
				'client/user/partial-update',
				{
					pushToken,
				},
				getAuthHeaders(token)
			);
		} catch (error) {
			handleServiceError(error);
		}
	},
};
